import Cookies from "js-cookie";
import "./formButtonValidation";
import "./is-find-office";
import "./eu-cookie-compliance";
import "./google-consent-mode";
import "./compress-header";

(function ($) {
  window.siwertell = {};
  siwertell.ref = {};

  siwertell.init = {
    // contact form
    contact_form: function () {
      $(".contact-form-toggle").click(function (e) {
        e.preventDefault();
        $(this).blur();
        $("html").toggleClass("show-contact-form");
      });

      // Toggle if user clicks outside box
      $(document).mouseup(function (e) {
        var formcontainer = $(".contact-form");
        var formtogglebtn = $(".contact-form-toggle");

        // Small menu box
        // if the target of the click isn't the container or the toggleButton or a descendant of the container
        if (
          !formcontainer.is(e.target) &&
          !formtogglebtn.is(e.target) &&
          formcontainer.has(e.target).length === 0
        ) {
          $("html").removeClass("show-contact-form");
        }
      });
    },

    // Messages
    messages: function () {
      var system_messages = $(".status-messages");
      if (system_messages.length) {
        // Add close buttons
        system_messages.find("> *").each(function () {
          $(
            '<button type="button" class="message-close button-close button-close-white">Close</button>'
          )
            .click(function (e) {
              e.preventDefault();
              $(this).blur();
              $(this).parent().addClass("message-hidden");
            })
            .appendTo($(this));
        });

        // Show the messages
        system_messages.addClass("show-messages");
      }
    },

    // Initial settings for the mainmenu
    menuSettings: function () {
      // Add extra class if sub menu is active
      const mainMenu = $(".primary-menu nav ul");
      mainMenu
        .find("ul a.is-active")
        .closest("ul")
        .prev("a")
        .addClass("is-active");
    },

    // smallMenu functions
    smallMenu: function () {
      // Toggle hamburger menu
      $(".toggle-navigation").click(function () {
        $("html").toggleClass("show-menu");

        $("html").removeClass("show-menu-language");
        if ($(".toggle-navigation-language").hasClass("active")) {
          $(".toggle-navigation-language").removeClass("active");
        }

        $(".show-menu .menu-smallscreen li .languages")
          .parent()
          .addClass("language-menu-item");
      });

      $(".toggle-navigation-language").click(function () {
        $(this).toggleClass("active");
        $("html").toggleClass("show-menu-language");

        $(".show-menu-language .menu-smallscreen li .languages")
          .parent()
          .addClass("language-menu-item");
        $(
          ".show-menu-language .menu-smallscreen li.language-menu-item"
        ).addClass("submenu-expanded");
        $("html").removeClass("show-menu");
      });

      // Side menu should have buttons that expand/contracts sub menu
      var side_menu = $(".menu-smallscreen");

      side_menu.find("ul ul").each(function () {
        var sub_menu = $(this);
        var button = $(
          '<button type="button" class="menu-smallscreen-toggle-submenu"></button>'
        )
          .appendTo(sub_menu.parent())
          .click(function () {
            // Remove class if other than this is expanded
            if (!$(this).closest("li").hasClass("submenu-expanded")) {
              side_menu
                .find(".submenu-expanded")
                .removeClass("submenu-expanded");
            }
            $(this).closest("li").toggleClass("submenu-expanded");
            $(this).blur();
          });
      });

      // Check if user clicked outside of box
      $(document).mouseup(function (e) {
        // smallmenu
        var container = $(".menu-smallscreen");
        var toggleButton = $(".toggle-navigation");

        // Small menu box
        // if the target of the click isn't the container or the toggleButton or a descendant of the container
        if (
          !container.is(e.target) &&
          !toggleButton.is(e.target) &&
          container.has(e.target).length === 0
        ) {
          $("html").removeClass("show-menu");
        }
      });
    },

    // Using fitvids to make embedvideos responsive
    fluidvids: function () {
      fluidvids.init({
        selector: ['iframe', 'object'], // runs querySelectorAll()
        players: ['www.youtube.com', 'player.vimeo.com'] // players to support
      });
    },

    // Expandables
    expandables: function () {
      $(".expandable__button button").on("click", function () {
        const $regionId = $(this).attr("aria-controls"),
          $region = $(this)
            .parents(".expandable")
            .find("#" + $regionId),
          regionExpanded = $region.attr("aria-expanded");

        if (regionExpanded === "false") {
          $(this).addClass("active");
          $region.attr("aria-expanded", true);
          $region.show();
        } else {
          $(this).removeClass("active");
          $region.attr("aria-expanded", false);
          $region.hide();
        }
      });
    },

    // Filter for downloads
    filter: function () {
      $("button[data-filter]").click(function (e) {
        var filter_name = $(this).data("filter");
        var active_class = "filter-button-active";

        // Set any buttons for this filter as active
        $('button[data-filter="' + filter_name + '"]')
          .addClass(active_class)
          .siblings()
          .removeClass(active_class);

        // Show all items if the filter is empty
        var filter_items = $("[data-filter]").not("button");
        if (filter_name == "") {
          filter_items.show();
        }

        // Show items with corresponding filter and hide the rest
        else {
          filter_items.filter('[data-filter="' + filter_name + '"]').show();
          filter_items.not('[data-filter="' + filter_name + '"]').hide();
        }
      });
    },

    backButton: function () {
      if (
        $("body").hasClass("node-product_area") ||
        $("body").hasClass("node-product") ||
        $("body").hasClass("node-product_article")
      ) {
        let href;
        let title;
        $(".legible a, .expandable .legible a").on("click", function (e) {
          if (
            $(".product-buttons").length &&
            $(".product-buttons a").hasClass("is-active")
          ) {
            href = $(".product-buttons a.is-active").attr("href");
            title = $.trim($(".product-buttons a.is-active").text());
          } else if (
            $(".center-large.case-image").length &&
            $(".center-large.case-image").find("header-1")
          ) {
            href = window.location.pathname;
            title = $(".center-large.case-image .header-1").text();
          } else {
            href = window.location.pathname;
            let page = href.split("/").pop();
            title = page.replace(/-/g, " ");
            title = title[0].toUpperCase() + title.slice(1);
          }

          var cookie_set = {
            backUrl: href,
            backUrlTitle: title,
            targetLink: e.target.href,
          };

          Cookies.set("back_button", JSON.stringify(cookie_set), {
            expires: 1,
          });
        });
      } else {
        // check for cookie data
        let readCookie = Cookies.get("back_button");
        if (typeof readCookie !== "undefined") {
          cookieData = JSON.parse(readCookie);
          let currentPage = window.location.href;
          let targetPath = cookieData.targetLink;

          if (targetPath == currentPage) {
            let backUrl = cookieData.backUrl;
            let title = cookieData.backUrlTitle;

            if ($(".center-small.legible").length) {
              $(".center-small.legible").prepend(
                '<p class="arrow-back">Back to <strong><a href="' +
                  backUrl +
                  '" hreflang="en">' +
                  title +
                  "</a></strong></p>"
              );
            }
          } else {
            Cookies.remove("back_button");
          }
        }
      }
    },
  };

  //
  // Go go go!
  //
  jQuery(document).ready(function () {
    // Run all setup functions
    for (var fn in siwertell.init) {
      if (siwertell.init.hasOwnProperty(fn)) {
        siwertell.init[fn]();
      }
    }
  });
})(jQuery);
